import { BaseDrawerWrapper } from '../Drawer.styles.js';
import { css, styled } from 'styled-components';

export const NavDrawerWrapper = styled(BaseDrawerWrapper)<{
  isOpen: boolean;
}>`
  ${({ theme }) => css`
    border-top: 1px solid ${theme.colorsV2.gray80};
    background: ${theme.colorsV2.black};
    top: 64px;
    bottom: 0px;
    z-index: ${theme.zIndices.navDrawer.dialog};
    ${theme.mediaQueries.sm} {
      top: 80px;
    }
  `}
`;

export const DrawerScreen = styled.div<{ isOpen: boolean }>`
  ${({ isOpen, theme }) => css`
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0);
    opacity: ${isOpen ? 0.5 : 0};
    z-index: ${isOpen ? theme.zIndices.navDrawer.backdrop : -1};
    transition: opacity 200ms ease-in-out;
  `}
`;
